// Calculs statistiques de la méthodologie. Implémentation jumelle de internal/stats (Go) ;
// les deux sont vérifiées contre testdata/vectors.json.
export const METHOD_VERSION = '1.0.0';
export function quantile(xs, q) {
    if (xs.length === 0)
        return NaN;
    const s = [...xs].sort((a, b) => a - b);
    const pos = q * (s.length - 1);
    const lo = Math.floor(pos);
    const hi = Math.ceil(pos);
    const a = s[lo];
    const b = s[hi];
    return lo === hi ? a : a + (b - a) * (pos - lo);
}
export const median = (xs) => quantile(xs, 0.5);
export function min(xs) {
    return xs.length === 0 ? NaN : Math.min(...xs);
}
export function mean(xs) {
    if (xs.length === 0)
        return NaN;
    let t = 0;
    for (const x of xs)
        t += x;
    return t / xs.length;
}
/** Écart absolu moyen entre échantillons consécutifs. */
export function jitter(xs) {
    if (xs.length < 2)
        return NaN;
    let t = 0;
    for (let i = 1; i < xs.length; i++)
        t += Math.abs(xs[i] - xs[i - 1]);
    return t / (xs.length - 1);
}
export function cv(xs) {
    const m = mean(xs);
    if (xs.length < 2 || m === 0 || Number.isNaN(m))
        return NaN;
    let v = 0;
    for (const x of xs)
        v += (x - m) ** 2;
    return Math.sqrt(v / (xs.length - 1)) / m;
}
export function trimmedMean(xs, lo, hi) {
    if (xs.length === 0)
        return NaN;
    const a = quantile(xs, lo);
    const b = quantile(xs, hi);
    const kept = xs.filter((x) => x >= a && x <= b);
    return kept.length === 0 ? median(xs) : mean(kept);
}
export const MIN_RAMP_S = 2;
export const MAX_RAMP_S = 6;
export const STABLE_TOLERANCE = 0.1;
export const STABLE_WINDOWS = 3;
export const ROBUST_LOW = 0.05;
export const ROBUST_HIGH = 0.95;
export const MIN_STABLE_SAMPLES = 5;
/** Indice du premier échantillon de la phase stable (fin du démarrage lent TCP). */
export function rampEnd(samples, interval) {
    const minIdx = Math.ceil(MIN_RAMP_S / interval);
    const maxIdx = Math.ceil(MAX_RAMP_S / interval);
    const win = Math.max(1, Math.round(0.5 / interval));
    if (minIdx >= samples.length)
        return samples.length;
    for (let i = minIdx; i <= maxIdx && i + win * STABLE_WINDOWS <= samples.length; i++) {
        let ok = true;
        let prev = mean(samples.slice(i, i + win));
        for (let w = 1; w < STABLE_WINDOWS; w++) {
            const cur = mean(samples.slice(i + w * win, i + (w + 1) * win));
            if (prev <= 0 || Math.abs(cur - prev) / prev > STABLE_TOLERANCE) {
                ok = false;
                break;
            }
            prev = cur;
        }
        if (ok)
            return i;
    }
    return maxIdx < samples.length ? maxIdx : minIdx;
}
/** Débit retenu (Mbit/s) : moyenne tronquée symétrique (5ᵉ–95ᵉ centile) de la phase stable. */
export function throughput(samples, interval) {
    const start = rampEnd(samples, interval);
    const stable = samples.slice(start);
    if (stable.length < MIN_STABLE_SAMPLES) {
        if (samples.length === 0)
            return { mbps: 0, start, ok: false };
        return { mbps: trimmedMean(samples, ROBUST_LOW, ROBUST_HIGH), start, ok: false };
    }
    return { mbps: trimmedMean(stable, ROBUST_LOW, ROBUST_HIGH), start, ok: true };
}
/** Note de réactivité sous charge (bufferbloat) selon l'augmentation de latence (ms). */
export function grade(increaseMs) {
    if (Number.isNaN(increaseMs))
        return '?';
    if (increaseMs <= 10)
        return 'A';
    if (increaseMs <= 30)
        return 'B';
    if (increaseMs <= 60)
        return 'C';
    if (increaseMs <= 100)
        return 'D';
    if (increaseMs <= 200)
        return 'E';
    return 'F';
}
/** Stabilité : les 3 dernières secondes varient de moins de 5 % (fenêtres de 500 ms à 100 ms d'échantillonnage). */
export function isStable(samples) {
    if (samples.length < 30)
        return false;
    const w = [];
    for (let i = samples.length - 30; i < samples.length; i += 5)
        w.push(mean(samples.slice(i, i + 5)));
    const c = cv(w);
    return !Number.isNaN(c) && c < 0.05;
}
